import _Promise from 'babel-runtime/core-js/promise';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import ExportXlsx from '@/components/ExportXlsxBtn/index.vue';
import searchMixin from '@/mixin/search';
import { fetchAdvertiserList } from '@/api/advertiser/manage';
import { loginAdvertiser } from '@/api/advertiser/manage';
import _ from 'lodash';
import { playTurboHostList } from '@/config/host';
import PermissionDialog from '../permission-dialog.vue';
import { NODE_ENV } from '@com/config/env';
import AdvertiserInfoDialog from '../../../advertiser/dialog.vue';
import VerifyEmailDialog from '../../../advertiser/verify-email-dialog.vue';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { currencyList, isPrePayList } from '@/views/advertiser/utils';
import { AdvertiserAccountTypeLabel } from '@/common/permission';

var createFromOptions = [{
  label: 'PT前台',
  value: 1
}, {
  label: '仓库后台',
  value: 2
}, {
  label: 'SS',
  value: 3
}, {
  label: '其他',
  value: 4
}, {
  label: 'Xmp',
  value: 5
}];

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    ExportXlsx: ExportXlsx,
    PermissionDialog: PermissionDialog,
    VerifyEmailDialog: VerifyEmailDialog,
    AdvertiserInfoDialog: AdvertiserInfoDialog
  },
  mixins: [searchMixin],
  data: function data() {
    var keyFieldConfig = [{
      value: 'id',
      label: '广告主ID'
    }, {
      value: 'name',
      label: '广告主名称'
    }, {
      value: 'email',
      label: '广告主邮箱'
    }];

    var statusConfig = [{
      value: 1,
      label: '是'
    }, {
      value: 2,
      label: '否'
    }];

    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: '',
        country: '',
        timezone: '',
        setting_final_review: '',
        setting_down_file: '',
        email: '',
        currency: '',
        cooperation_entity: '',
        advance: '',
        bd_id: '',
        bd_am_id: '',
        is_inner_test_account: ''
      },
      pagination: {
        total: 0
      },
      sheetBody: [],
      listLoading: true,
      keyFieldConfig: keyFieldConfig,
      statusConfig: statusConfig,
      timeZoneList: [],
      countryList: [],
      list: [],
      formConfig: {
        labelPosition: 'left',
        labelWidth: '100px'
      },

      advertiserOptions: [],
      currentAdvertiser: {},
      permissionDialog: {
        visible: false
      }
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '广告主Id',
        prop: 'id',
        width: 100
      }, {
        label: '广告主名称',
        prop: 'name'
      }, {
        label: '账号类型',
        prop: 'mws_account_type',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return AdvertiserAccountTypeLabel[row.mws_account_type] || '-';
          }
        }
      }, {
        label: '来源',
        prop: 'create_from',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return useValueExchangeLabel(row.create_from, createFromOptions) || '-';
          }
        }
      }, {
        label: '时区',
        prop: 'timezone'
      }, {
        label: '国家',
        prop: 'country',
        width: 100
      }, {
        label: '结算币种',
        prop: 'currency'
      }, {
        label: '合作主体',
        prop: 'cooperation_entity_label'
      }, {
        label: '是否预付',
        prop: 'advance'
      }, {
        label: '联系方式',
        prop: 'contact_num'
      }, {
        label: '联系人',
        prop: 'contact'
      }, {
        label: '广告主邮箱',
        prop: 'email'
      }, {
        label: 'BD',
        prop: 'bd'
      }, {
        label: 'BD_AM',
        prop: 'bd_am'
      }, {
        label: '是否内测账号',
        prop: 'is_inner_test_account',
        width: 100
      }, {
        label: 'MTG可授权广告账户数',
        prop: 'pt_mintegral_account_limit',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return row.pt_mintegral_account_limit || '-';
          }
        }
      }, {
        label: '备注',
        prop: 'remark'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    },
    sheetHeader: function sheetHeader() {
      var headers = {};
      this.tableColumnConfig.forEach(function (item) {
        if (item.prop) headers[item.prop] = item.label;
      });
      return _extends({}, headers);
    },
    formItemList: function formItemList() {
      var _this = this;

      var nameKeywordSearchItem = {
        prop: 'keyword',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'name',
          clearable: true
        }
      };

      var otherKeywordSearchItem = {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref4) {
          var formValue = _ref4.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      };
      var keywordItem = this.query.search_field === 'name' ? nameKeywordSearchItem : otherKeywordSearchItem;
      return [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型',
          handleChange: function handleChange(val) {
            _this.query.keyword = '';
          }
        }
      }, keywordItem, {
        prop: 'timezone',
        type: 'select',
        params: {
          filterable: true,
          clearable: true,
          options: this.timeZoneList,
          placeholder: '请选择时区'
        }
      }, {
        prop: 'country',
        type: 'select',
        params: {
          filterable: true,
          clearable: true,
          options: this.countryList,
          placeholder: '请选择国家'
        }
      }, {
        prop: 'currency',
        type: 'select',
        params: {
          clearable: true,
          options: currencyList,
          placeholder: '请选择结算币种'
        }
      }, {
        prop: 'cooperation_entity',
        type: 'select',
        params: {
          clearable: true,
          options: this.advertiserOptions.adv_cooperation_entity || [],
          placeholder: '请选择合作主体'
        }
      }, {
        prop: 'advance',
        type: 'select',
        params: {
          clearable: true,
          options: isPrePayList,
          placeholder: '请选择是否预付'
        }
      }, {
        prop: 'bd_id',
        type: 'select',
        params: {
          filterable: true,
          clearable: true,
          options: this.advertiserOptions.bd || [],
          placeholder: '请选择BD'
        }
      }, {
        prop: 'bd_am_id',
        type: 'select',
        params: {
          filterable: true,
          clearable: true,
          options: this.advertiserOptions.bd_am || [],
          placeholder: '请选择BD_AM'
        }
      }, {
        prop: 'setting_final_review',
        type: 'select',
        params: {
          clearable: true,
          options: this.statusConfig,
          placeholder: '是否素材二审广告主'
        }
      }, {
        prop: 'setting_down_file',
        type: 'select',
        params: {
          clearable: true,
          options: this.statusConfig,
          placeholder: '是否允许下载非交互素材'
        }
      }, {
        prop: 'is_inner_test_account',
        type: 'select',
        params: {
          clearable: true,
          options: this.statusConfig,
          placeholder: '是否内测账号'
        }
      }];
    },
    playTurboUrl: function playTurboUrl() {
      return playTurboHostList[NODE_ENV] + '/#/auth';
    }
  },

  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getDependencyData();

            case 2:
              _context.next = 4;
              return _this2.renderList();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    renderList: function renderList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return fetchAdvertiserList(_this3.query);

              case 4:
                res = _context2.sent;

                _this3.list = (_.get(res, 'data.data.list') || []).map(function (advertiser) {
                  return _this3.cookAdvertiser(advertiser);
                });
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                _this3.listLoading = false;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 10]]);
      }))();
    },
    request: function request(params) {
      return fetchAdvertiserList(_extends({}, this.query, params));
    },
    cookAdvertiser: function cookAdvertiser(advertiser) {
      var temp = _extends({}, advertiser, {
        currency: useValueExchangeLabel(advertiser.currency, currencyList) || '-',
        advance: useValueExchangeLabel(advertiser.advance, isPrePayList) || '-',
        is_inner_test_account: useValueExchangeLabel(advertiser.is_inner_test_account, isPrePayList) || '-',
        timezone: this.formatTimeZone(advertiser),
        bd: useValueExchangeLabel(advertiser.bd_id, this.advertiserOptions.bd || []) || '-',
        bd_am: useValueExchangeLabel(advertiser.bd_am_id, this.advertiserOptions.bd_am || []) || '-',
        cooperation_entity_label: useValueExchangeLabel(advertiser.cooperation_entity, (this.advertiserOptions.adv_cooperation_entity || []).filter(function (item) {
          return item.currency === advertiser.currency;
        })) || '-'
      });
      return temp;
    },
    cookSheetList: function cookSheetList(res) {
      var _this4 = this;

      var list = (_.get(res, 'data.data.list') || []).map(function (advertiser) {
        var temp = _this4.cookAdvertiser(advertiser);
        return temp;
      });
      return list;
    },
    formatTimeZone: function formatTimeZone(_ref5) {
      var timezone = _ref5.timezone;

      var item = this.timeZoneList.find(function (item) {
        return Number(item.value) === Number(timezone);
      });
      if (item) {
        return item.label.split('(')[0];
      }
      return '-';
    },
    login: function login(row, type) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var newTab, close, res, token;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newTab = window.open('about:blank');

                close = function close() {
                  if (newTab) {
                    newTab.close();
                    newTab = null;
                  }
                };

                _context3.prev = 2;
                _context3.next = 5;
                return loginAdvertiser({
                  id: row.id
                });

              case 5:
                res = _context3.sent;

                if (res.data.code === 0) {
                  token = _.get(res, 'data.data.token') || '';

                  newTab.location.href = (type === 'inland' ? _this5.playTurboUrl.replace('.com', '.cn') : _this5.playTurboUrl) + '?token=' + token;
                  newTab = null;
                } else {
                  close();
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](2);

                close();

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[2, 9]]);
      }))();
    },
    openPermissionDialog: function openPermissionDialog(data) {
      this.currentAdvertiser = data;
      this.permissionDialog.visible = true;
    },
    openAdvertiserDialog: function openAdvertiserDialog() {
      this.$store.dispatch('advertiser/openVerifyDialog');
    },
    openEditAdvertiserDialog: function openEditAdvertiserDialog(data) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.$store.dispatch('advertiser/openDialog', {
                  type: 'edit',
                  id: data.id
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getDependencyData: function getDependencyData() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _ref6, _ref7, _ref7$, advertiserOptions, _ref7$2, countryList, _ref7$3, timeZoneList;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _Promise.all([_this7.$store.dispatch('advertiser/getOptions'), _this7.$store.dispatch('config/getCountryList'), _this7.$store.dispatch('config/getTimeZoneList')]);

              case 2:
                _ref6 = _context5.sent;
                _ref7 = _slicedToArray(_ref6, 3);
                _ref7$ = _ref7[0];
                advertiserOptions = _ref7$ === undefined ? {} : _ref7$;
                _ref7$2 = _ref7[1];
                countryList = _ref7$2 === undefined ? [] : _ref7$2;
                _ref7$3 = _ref7[2];
                timeZoneList = _ref7$3 === undefined ? [] : _ref7$3;

                _this7.advertiserOptions = advertiserOptions;
                _this7.countryList = countryList;
                _this7.timeZoneList = timeZoneList;

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.renderList();
    }
  }
};